import { useFormField } from '@frontend/design-system';

export type TimeRangeId = 'early-morning' | 'late-morning' | 'early-afternoon' | 'late-afternoon' | 'evening';

export type TimeRange = {
  id: TimeRangeId;
  label: string;
  startHour: number;
  endHour: number;
  extendedLabel: string;
};

export const TIME_RANGES: TimeRange[] = [
  { id: 'early-morning', label: 'Early Morning', extendedLabel: 'before 10 AM', startHour: 0, endHour: 10 },
  { id: 'late-morning', label: 'Late Morning', extendedLabel: '10 AM - 12 PM', startHour: 10, endHour: 12 },
  { id: 'early-afternoon', label: 'Early Afternoon', extendedLabel: '12 PM - 3 PM', startHour: 12, endHour: 15 },
  { id: 'late-afternoon', label: 'Late Afternoon', extendedLabel: '3 PM - 6 PM', startHour: 15, endHour: 18 },
  { id: 'evening', label: 'Evening', extendedLabel: 'after 6 PM', startHour: 18, endHour: 24 },
];

export type AvailabilityFilters = {
  serviceId: string;
  locationId: string;
  timeRanges: TimeRange[];
  operatoryIds: string[];
  providerIds: string[];
  weekStartDate: string;
  weekEndDate: string;
};

export type AvailabilityHeaderFieldProps = {
  weekInView: string;
  weekDatePicker: ReturnType<typeof useFormField<'datePicker'>>;
  handleDateChange: ReturnType<typeof useFormField<'datePicker'>>['onChange'];
  goToNextWeek: () => void;
  goToPreviousWeek: () => void;
  goToThisWeek: () => void;
  isCurrentWeek: boolean;
  selectedServiceId: string | undefined;
  onServiceSelect: (id: string) => void;
  isMultiLocation: boolean;
  locationOptions: { value: string; label: string }[];
  locationRadioField: ReturnType<typeof useFormField<'radio'>>;
  timeRangeOptions: { value: string; label: string }[];
  timeRangeChecklistField: ReturnType<typeof useFormField<'checklist'>>;
  operatories: { value: string; label: string }[];
  operatoryChecklistField: ReturnType<typeof useFormField<'checklist'>>;
  providers: { value: string; label: string }[];
  providerChecklistField: ReturnType<typeof useFormField<'checklist'>>;
};

export type UseAvailabilityFiltersArgs = {
  locationId: string;
  orgId: string;
  initialServiceId?: string;
};
